import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { SearchInputResult } from '../../../search/components/search-bar/SearchLocationResults';
import { getImagePath } from '../../../../helpers/common';
import { useSelector } from 'react-redux';
import { Destination, MapMode } from '../../types';
import { useEffect, useState } from 'react';
import DestinationIcon from '../calculate-distance/DestinationIcon';
import CheckedIcon from '../../../../new-components/svg-icons/CheckedIcon';
import { useTranslation } from 'next-i18next';
import SearchIcon from '../../../../new-components/svg-icons/SearchIcon';

interface SearchResultProps {
  result: SearchInputResult;
  handleClick: (result: SearchInputResult) => void;
  destination?: Destination;
}

const SearchResult = ({
  result,
  handleClick,
  destination
}: SearchResultProps) => {
  const { t } = useTranslation(['search', 'common']);

  const mapMode = useSelector((state: any) => state.map.mapMode);

  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const checkSelection = () => {
    if (mapMode === MapMode.COMPOUND && result.id === selectedCompound?.id) {
      setIsSelected(true);
    } else if (mapMode === MapMode.CalculateDistance) {
      if (destination === 'a' && result.id === firstDestination?.id) {
        setIsSelected(true);
      } else if (destination === 'b' && result.id === secondDestination?.id) {
        setIsSelected(true);
      } else {
        setIsSelected(false);
      }
    } else {
      setIsSelected(false);
    }
  };
  const checkDisabled = () => {
    const isSahelCompound =
      result?.area_id === 3 ||
      result?.parent_area_name?.en.includes('North Coast');

    if (
      mapMode === MapMode.CalculateDistance &&
      (!isSahelCompound ||
        (destination === 'a' && result.id === secondDestination?.id) ||
        (destination === 'b' && result.id === firstDestination?.id))
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };

  const onClick = () => {
    handleClick(result);
  };

  useEffect(() => {
    checkSelection();
    checkDisabled();
  }, [
    mapMode,
    firstDestination,
    secondDestination,
    selectedCompound,
    destination
  ]);
  return (
    <Container
      onClick={onClick}
      disabled={isDisabled}
      isSelected={isSelected}
      isDisabled={isDisabled}
    >
      <div className="info">
        {result.category !== 'area' ? (
          <ImageWrapper
            src={getImagePath(result?.image_path)}
            alt="Search Result Image"
            width={32}
            height={32}
            objectFit="cover"
            style={{ borderRadius: '4px' }}
          />
        ) : (
          <SearchIcon />
        )}
        <span>{result.name}</span>
      </div>

      {result.category !== 'compound' && (
        <span className="type">{t(result.category, { ns: 'common' })}</span>
      )}

      {mapMode === MapMode.CalculateDistance && (
        <>
          {!isSelected &&
            destination === 'b' &&
            result.id === firstDestination?.id && (
              <DestinationIcon
                destination="a"
                background="#015C9A"
                color="#fff"
              />
            )}
          {!isSelected &&
            destination === 'a' &&
            result.id === secondDestination?.id && (
              <DestinationIcon
                destination="b"
                background="#015C9A"
                color="#fff"
              />
            )}
        </>
      )}

      {mapMode === MapMode.COMPOUND && isSelected && (
        <div className="checked-icon">
          <CheckedIcon fill="#fff" />
        </div>
      )}
    </Container>
  );
};

const Container = styled.button<{ isSelected: boolean; isDisabled: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 8px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  //border-radius: 8px;
  border: none;
  background-color: transparent;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};

  &:hover {
    background-color: rgba(118, 173, 225, 0.08);
  }

  &:not(:first) {
    border-top: 1px solid #f0f1f3;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f1f3;
  }

  .info {
    display: flex;
    align-items: center;
    text-align: start;
    gap: 8px;
    overflow: hidden;
    margin-inline-start: 4px;
    span {
      color: #2c3138;
      font-size: 14px;
      font-family: materialMedium;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    svg {
      width: 16px;
      height: 16px;
      path {
        fill: #646464;
      }
    }
  }

  .type {
    color: rgb(33, 36, 39);
    background-color: rgb(240, 240, 240);
    padding: 2.5px 8px;
    font-size: 12px;
    font-family: materialMedium;
    min-width: fit-content;
    border-radius: 35px;
    text-transform: capitalize;
  }

  .checked-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 10px;
    background-color: #ff9354;
    border-radius: 360px;
    border: 1px solid #d1d4d9;
    color: #fff;
    font-size: 17px;
    font-family: materialBold;
  }
`;

export default SearchResult;
